import React, { useState } from 'react';
import ModuleHeader from '../common/ModuleHeader';
import { Wallet, Receipt, BookOpen, Smartphone } from 'lucide-react';
import FolioJournalier from './FolioJournalier';
import FolioMobileMoney from './FolioMobileMoney';
import BonsEnAttente from './BonsEnAttente';

type TabType = 'folio' | 'mobile' | 'bons';

const CaisseModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('folio');

  const tabs = [
    { id: 'folio' as TabType, name: 'Folio de caisse', icon: BookOpen },
    { id: 'mobile' as TabType, name: 'Folio Mobile Money', icon: Smartphone },
    { id: 'bons' as TabType, name: "Bons en attente", icon: Receipt },
  ];

  return (
    <div className="w-full space-y-5">
      <ModuleHeader
        title="Caisse"
        subtitle="Folio journalier, Mobile Money et bons de consultation"
        icon={Wallet}
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
      />

      <div className="w-full">
        {activeTab === 'folio' && <FolioJournalier />}
        {activeTab === 'mobile' && <FolioMobileMoney />}
        {activeTab === 'bons' && <BonsEnAttente />}
      </div>
    </div>
  );
};

export default CaisseModule;
